<template lang="pug">
  div
    el-row.labelStyle
      el-col(:span="12")
        app-display(
          label="Nome UC",
          :content="dadosJson.informacoesAdministrativasUc.nomeUc || '-'",
        )
        app-display(
          label="Esfera Administrativa:",
          :content="dadosJson.informacoesAdministrativasUc.esferaAdministrativa || '-'",
        )
        app-display(
          label="Objetivo Criação UC:",
          :content="dadosJson.informacoesAdministrativasUc.objetivoCriacaoUc || '-'",
        )
        app-display(
          label="Órgão Gestor:",
          :content="dadosJson.informacoesAdministrativasUc.orgaoGestor || '-'",
        )
      el-col(:span="12")
        app-display(
          label="Tipo UC:",
          :content="dadosJson.informacoesAdministrativasUc.tipoUc || '-'",
        )
        app-display(
          label="Tipo UC Proteção Integral:",
          :content="dadosJson.informacoesAdministrativasUc.tipoUcProtecaoIntegral || '-'",
        )
        app-display(
          label="Tipo UC Uso Sustentável:",
          :content="dadosJson.informacoesAdministrativasUc.tipoUcUsoSustentavel || '-'",
        )
</template>
<script>
import AppDivider from '../AppDivider'
import AppDisplay from '../AppDisplay'
import AppDisplayMultiple from '@/components/AppDisplayMultiple'

export default {
  props: {
    dadosJson: {
      type: Object,
      required: false
    }
  },
  components: {
    AppDisplay,
    AppDivider,
    AppDisplayMultiple
  },

  methods: {
    formatTelefone (telefones) {
      return telefones.map(telefone => {
        if (telefone?.numero) {
          return telefone.numero + (telefone.identificacao ? ` - ${telefone.identificacao}` : '')
        } else {
          return telefone
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.margin-top {
    margin-top: 10px;
}

>>>.text .text {
    color: #ff0000 !important;
}

@media (max-width: 780px) {
    .labelStyle {
        display: flex;
        flex-direction: column;
        width: 395px;
    }

    .margin-top {
        display: flex;
        flex-direction: column;
        width: 490px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/InformacoesAdministrativasUc.vue